import React, {useCallback, useEffect, useState} from "react";
import {makeRequest} from "js/services/Network";


function BuyerFomo() {
  const [users, setUsers] = useState(['adelekesamuel620','blessingkalu061',"saeedumala", "jfashak01234", "alvinsomto9", "benjaminadeboye238", "sallieagba", "olamilekanabdulhamid21", "progressolamiprosper"]);
  const [transactions, setTransactions] = useState(['temitope','theladyswann','gr8skills1','thanau','odogwu']);



  const fetchData = async () => {
    let login = AppUser.isLoggingIn ? AppUser.login : 'Jeff';
    await makeRequest('buyer-landing-page-fomo-data', {login: login}).then(json => {
      setUsers(users => [...users, ...json.data.recent_users] );
      setTransactions(transactions => [...transactions, ...json.data.recent_transactions] );
    });
  }


  const randomUser = Math.floor(Math.random() * users.length);
  const randomTransaction = Math.floor(Math.random() * transactions.length);
  const signup1 = users[Math.floor(Math.random() * users.length)];
  const signup2 = users[Math.floor(Math.random() * users.length)];
  const signup3 = users[Math.floor(Math.random() * users.length)];
  const trans1 = transactions[Math.floor(Math.random() * transactions.length)];
  const trans2 = transactions[Math.floor(Math.random() * transactions.length)];
  // console.log(signup1,trans1);
  const fomo = [
    `🔥 ${signup1} just signed up to start using PayOnDelivery`,
    `🔥 ${signup2} just signed up to start using PayOnDelivery`,
    `🔥 @${trans1} just completed a transaction!`,
    `🔥 ${signup3} just signed up to start using PayOnDelivery`,
    `🔥 @${trans2} just completed a transaction!`,
  ];

  useEffect( async () => {
    let login = AppUser.isLoggingIn ? AppUser.login : 'Jeff';
    await makeRequest('buyer-landing-page-fomo-data', {login: login}).then(json => {
      setUsers(users => [...users, ...json.data.recent_users] );
      setTransactions(transactions => [...transactions, ...json.data.recent_transactions] );
    });
  }, []);

  useEffect( () => {
    const intervalID = setInterval(shuffle, 7000);
    return () => clearInterval(intervalID);
  }, [shuffle])

  const [newFomo, setnewFomo ] = useState(`🔥 jeff just signed up to start using PayOnDelivery`)

  const shuffle = useCallback(() => {
    const index = Math.floor(Math.random() * fomo.length);
    setnewFomo(fomo[index]);
  }, []);


  return (
    <div className="md:tw-w-[70%] tw-w-full" style={{lineHeight:'26px'}}>
      <p style={{textAlign:'center', backgroundColor:'#FFEACB', paddingTop:'16px', paddingBottom:'16px', fontWeight:600, fontSize:'14px', lineHeight:'21px'}}>{newFomo}</p>
    </div>
  )
}
export default BuyerFomo
